module.exports = __webpack_public_path__ + "assets/47adb18cca9326362a093cb8b3dfee2b.mp4";